import { useEffect, useRef, useState } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import "./layout.scss";
import { Button, Dropdown } from "react-bootstrap";
import LogoWhite from "../../images/logo-white.png";
import MenuIcon from "../../images/menu_open.png";
import LogoSM from "../../images/logo-sm.png";
import { dispatchAuth } from "../../redux/action";
import { connect } from "react-redux";
import userEvent from "@testing-library/user-event";
import { apiUrl } from "../../base/utils";
import { invokeGetService, invokePostService } from "../../service";
import IntegraLogo from "../../images/integra-logo.png";
import moment from "moment";

function Layout(props: any) {
  const [sideBar, setSidebar] = useState(true);
  const [menuItems, setUserMenus] = useState<any>([]);
  const navigate = useNavigate();
  const [notificationList, setNotificationList] = useState<any>({});
  const [countNotification, setCountNotification] = useState(0);
  const [dummy, setDummy] = useState(0);
  const authorMenu: any = [
    { path: "/dashboard", icon: "dashboard", label: "Dashboard" },
    { path: "/submitarticle", icon: "event_note", label: "Manuscript Summary" },
    // { path: "/usermanagement", icon: "event_note", label: "User Management" },

    // Add more items as needed
  ];
  const reviewerMenu: any = [
    { path: "/reviewermanuscript", icon: "event_note", label: "Manuscript Summary" },
    // Add more items as needed
  ];
  const [showDropdown, setShowDropdown] = useState(false);
  const editorMenu: any = [
    { path: "/dashboardcontent", icon: "dashboard", label: "Dashboard" },
    { path: "/manuscript", icon: "event_note", label: "Manuscript summary" },
    { path: "/usermanagement", icon: "event_note", label: "User Management" },
    { path: "/movearticle", icon: "event_note", label: "Move article to production" },
    // { path: "/journalandissue" ,icon: "event_note", label: "Journal & Issue Config" }
  ];

  const windowWith = useRef<HTMLDivElement>(null);
  const bodyClassName = process.env.REACT_APP_BODY_CLASS || "";

  useEffect(() => {
    if (props.refresh === "refreshNotification") {
      getNotification();
      const newNumber = Math.floor(Math.random() * 1000);
      setDummy(newNumber);
    }
  }, [props.autogenerate]);
  const getNotification = async () => {
    try {
      let url;
      if (
        props.userInfo.roles.filter((list: any) => list.roleid == 1).length > 0
      ) {
        url = apiUrl.nodeApi.getNotification;
      } else if(props.userInfo.roles.filter((list: any) => list.roleid == 2).length > 0){
        url = apiUrl.nodeApi.getNotification;
      }else{
        url = apiUrl.nodeApi.getReviewerNotification;
      }
    
      const response: any = await invokeGetService(url, {}, {}, props.isToken);

      // Check if response.data is defined
      if (response.data && response.data.data && response.data.data.result) {
        const { result } = response.data.data;

        // Check if result.data is defined and not an empty object
        if (result.data && Object.keys(result.data).length > 0) {
          setNotificationList(result.data);
        }

        // Check if result.unReadCount is defined
        if (result.unReadCount !== undefined) {
          setCountNotification(result.unReadCount);
        }
      }
    } catch (error) {
      // Handle errors here
      console.error("Error fetching notifications:", error);
    }
  };

  useEffect(() => {
    if (props?.userInfo?.roles) {
      if (
        props.userInfo.roles.filter((list: any) => list.roleid === 1).length > 0
      ) {
        setUserMenus(authorMenu);
      } else if(props.userInfo.roles.filter((list: any) => list.roleid === 2).length > 0) {
        setUserMenus(editorMenu);
      }else{
        setUserMenus(reviewerMenu); 
      }
    } else {
      navigate("/login");
    }

    getNotification();
    let screenWidth: any = windowWith?.current?.clientWidth;
    if (screenWidth >= 1024) {
      setSidebar(true);
    } else {
      setSidebar(false);
    }
    // commented out because for now requirement is to have default logo which is integra logo
    const bodyClassName = process.env.REACT_APP_BODY_CLASS || "";
    console.log(bodyClassName, "bodyClassName");
    document.querySelector("body")?.classList.remove("demo-body");
    document.querySelector("body")?.classList.add("demo-body");
  }, []);

  const getUserMenu = async () => {
    try {
      let url = apiUrl.nodeApi.getusermenu;
      //  const response = await axios.get(`${config.prapp.basURL}${url}`);
      let payload = {
        roles: props.userInfo.roles,
      };
      const response: any = await invokeGetService(
        url,
        payload,
        {},
        props.isToken
      );
      setUserMenus(response.data.data.result);
    } catch (error) {}
  };

  const sidebarExpand = () => {
    setSidebar(!sideBar);
  };

  const navigateLogin = () => {
    //remove all the local storage
    // localStorage.clear();
    localStorage.removeItem("token");
    props.dispatchAuth(false, null, null);
    navigate("/login");
  };

  const handleProfile = () => {
    if (
      props.userInfo.roles.filter((list: any) => list.roleid == 1).length > 0
    ) {
      navigate("/authorprofile");
    } else if(props.userInfo.roles.filter((list: any) => list.roleid == 2).length > 0){
      navigate("/viewprofile");
    }else{
      navigate("/viewprofile");
    }
  };

  const moveAll = () => {
    setShowDropdown(!showDropdown);
    setCountNotification(0);
    navigate("/notification", { state: { type: "viewall" } });
  };
  
  const handleNavigateInstruction = () => {
    // navigate("/instruction");
    window.open("/instruction", "_blank");

    // window.open("/instruction", "_blank");
  }

  return (
    <div
      className={sideBar === true ? `layout lg` : `layout sm`}
      ref={windowWith}
    >
      {/* <div className='leftside-bar'>
                <div className='sidebar-logo'>
                    <img src={sideBar === true ? LogoWhite : LogoSM} alt="logo" />
                </div>
                <ul>
                    <li><NavLink to="/dashboard">
                        <span className="material-icons">
                            dashboard
                        </span> <label>Dashboard</label></NavLink></li>
                    <li><NavLink to="/submitarticle">
                        <span className="material-icons">
                            event_note
                        </span> <label>Submit Article </label></NavLink></li>
                </ul>
            </div> */}
      <div className="leftside-bar">
        <div className="sidebar-logo">
          <img
            src={sideBar ? LogoWhite : LogoSM}
            alt="logo"
            className="no-demo"
          />
          <div className="demo">
            {sideBar === true ? (
              <>
                <img src={IntegraLogo} alt="logo" />
              </>
            ) : (
              <div className="text-logo">in</div>
            )}
          </div>
        </div>
        <ul>
          {menuItems.map((item: any, index: any) => (
            <li
              key={index}
              className={item.label === "Dashboard" ? "dashboard" : ""}
            >
              <NavLink to={item.path}>
                <span className="material-icons">{item.icon}</span>{" "}
                <label>{item.label}</label>
              </NavLink>
              <p>PLATFORM</p>
            </li>
          ))}
        </ul>
      </div>
      <div className="container-box">
        <header>
          <Button className="menu-btn" onClick={sidebarExpand}>
            <img src={MenuIcon} alt="menu-icon" />
          </Button>
          <div>
            {/* <Button className='iconBtn'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.6432 0.564453C12.5174 0.564453 10.8038 1.96121 9.1466 3.31211C7.6466 4.53472 6.2298 5.68943 4.6594 5.68943H2.0546C0.9216 5.68943 0 6.596 0 7.71097V9.41943C0 10.5342 0.9216 11.4408 2.0546 11.4408H2.1702V15.3986C2.1702 16.5134 3.092 17.4202 4.225 17.4202H5.0932C6.2262 17.4202 7.1478 16.5134 7.1478 15.3986V12.3078C7.8112 12.7315 8.4702 13.2677 9.146 13.8187C10.8034 15.1692 12.517 16.5663 14.6428 16.5663C16.5254 16.5661 18 13.0518 18 8.56539C18 4.07877 16.5254 0.564453 14.6432 0.564453ZM6.5114 15.3988C6.5114 16.168 5.8752 16.7938 5.0934 16.7938H4.2252C3.4432 16.7938 2.807 16.168 2.807 15.3988V11.4408H4.6594C5.2968 11.4408 5.9088 11.6334 6.5114 11.941V15.3988ZM9.5526 13.3362C8.0318 12.0962 6.4592 10.8144 4.6594 10.8144H2.0546C1.2728 10.8144 0.6366 10.1886 0.6366 9.41943V7.71097C0.6366 6.94175 1.2728 6.31579 2.0546 6.31579H4.6592C6.459 6.31579 8.0314 5.03375 9.5524 3.79443C10.664 2.88844 11.8026 1.96298 13.0456 1.49818C11.9898 2.83157 11.286 5.46608 11.286 8.56539C11.286 11.6641 11.9896 14.2988 13.0452 15.6318C11.8026 15.1674 10.664 14.2419 9.5526 13.3362ZM14.6432 15.9398C13.3294 15.9398 11.9228 12.9766 11.9228 8.56539C11.9228 4.15394 13.3292 1.19061 14.6432 1.19061C15.9568 1.19061 17.3634 4.15394 17.3634 8.56539C17.3632 12.9766 15.9568 15.9398 14.6432 15.9398Z" fill="black" />
                            </svg>
                            <span>3</span>
                        </Button> */}
             <Dropdown className="help-icon">
      <Dropdown.Toggle id="dropdown-custom-components">
      <span className="material-symbols-outlined">help</span>
      </Dropdown.Toggle>
      <Dropdown.Menu>
  <Dropdown.Item onClick={handleNavigateInstruction} className="help-item">
    <span className="material-icons">menu_book</span> Quick Reference Guide
  </Dropdown.Item>
  <Dropdown.Item href="/PeerEase_Product_Brief.pdf" target="_blank" className="help-item">
    <span className="material-icons">description</span> User Manual
  </Dropdown.Item>
  <Dropdown.Item className="help-item support-team" onClick={(e) => e.stopPropagation()}>
  <span className="material-icons">support_agent</span> Support Team
  <a 
    href="mailto:product.support@integra.co.in" 
    className="support-email"
    onClick={(e) => {
      e.preventDefault();
      window.location.href = "mailto:product.support@integra.co.in";
    }}
  >
    product.support@integra.co.in
  </a>
</Dropdown.Item>

</Dropdown.Menu>

    </Dropdown>
            
            <Dropdown
              className="iconBtn notification-icons"
              show={showDropdown}
              onToggle={() => setShowDropdown(!showDropdown)}
            >
              <Dropdown.Toggle variant="success" id="dropdown-basic">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.6432 0.564453C12.5174 0.564453 10.8038 1.96121 9.1466 3.31211C7.6466 4.53472 6.2298 5.68943 4.6594 5.68943H2.0546C0.9216 5.68943 0 6.596 0 7.71097V9.41943C0 10.5342 0.9216 11.4408 2.0546 11.4408H2.1702V15.3986C2.1702 16.5134 3.092 17.4202 4.225 17.4202H5.0932C6.2262 17.4202 7.1478 16.5134 7.1478 15.3986V12.3078C7.8112 12.7315 8.4702 13.2677 9.146 13.8187C10.8034 15.1692 12.517 16.5663 14.6428 16.5663C16.5254 16.5661 18 13.0518 18 8.56539C18 4.07877 16.5254 0.564453 14.6432 0.564453ZM6.5114 15.3988C6.5114 16.168 5.8752 16.7938 5.0934 16.7938H4.2252C3.4432 16.7938 2.807 16.168 2.807 15.3988V11.4408H4.6594C5.2968 11.4408 5.9088 11.6334 6.5114 11.941V15.3988ZM9.5526 13.3362C8.0318 12.0962 6.4592 10.8144 4.6594 10.8144H2.0546C1.2728 10.8144 0.6366 10.1886 0.6366 9.41943V7.71097C0.6366 6.94175 1.2728 6.31579 2.0546 6.31579H4.6592C6.459 6.31579 8.0314 5.03375 9.5524 3.79443C10.664 2.88844 11.8026 1.96298 13.0456 1.49818C11.9898 2.83157 11.286 5.46608 11.286 8.56539C11.286 11.6641 11.9896 14.2988 13.0452 15.6318C11.8026 15.1674 10.664 14.2419 9.5526 13.3362ZM14.6432 15.9398C13.3294 15.9398 11.9228 12.9766 11.9228 8.56539C11.9228 4.15394 13.3292 1.19061 14.6432 1.19061C15.9568 1.19061 17.3634 4.15394 17.3634 8.56539C17.3632 12.9766 15.9568 15.9398 14.6432 15.9398Z"
                    fill="black"
                  />
                </svg>
                {countNotification !== 0 ? (
                  <span>{countNotification}</span>
                ) : (
                  ""
                )}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Header>
                  Notification{" "}
                  <label>
                    {countNotification !== 0 ? (
                      <span>{countNotification} New Notification</span>
                    ) : (
                      ""
                    )}
                  </label>
                </Dropdown.Header>
                <div className="notification-list">
                  {Object.keys(notificationList).length ? (
                    <>
                      {Object.keys(notificationList).map(
                        (item: any, index: any) => {
                          let arrayItem = notificationList[item];
                          return arrayItem?.map((list: any, a: any) => (
                            <div
                              className={`notification-list-inner ${
                                !list.isnotified ? "non-reader" : ""
                              }`}
                            >
                                <div className='notification-icon'>
                    <span className="material-icons" style={{ 
                      fontSize: '24px', 
                      color: !list.isnotified ? '#007bff' : '#6c757d' 
                    }}>
                      notifications
                    </span>
                  </div>
                              <div className="notification-details">
                                <p>{list.status_description}</p>
                                <span>
                                  {moment(new Date().toISOString()).diff(
                                    moment(list.notificationdate),
                                    "hours"
                                  ) < 24
                                    ? moment(new Date()).diff(
                                        moment(list.notificationdate),
                                        "hours"
                                      ) < 1
                                      ? moment(new Date()).diff(
                                          moment(list.notificationdate),
                                          "minutes"
                                        ) + " m ago"
                                      : moment(new Date()).diff(
                                          moment(list.notificationdate),
                                          "hours"
                                        ) + " h ago"
                                    : moment(new Date().toISOString()).diff(
                                        moment(list.notificationdate),
                                        "days"
                                      ) + " day ago"}
                                </span>
                              </div>
                            </div>
                          ));
                        }
                      )}
                    </>
                  ) : (
                    <p>No Notification</p>
                  )}
                </div>
                <div className="footer">
                  <Button onClick={moveAll}>VIEW ALL</Button>
                </div>
              </Dropdown.Menu>
            </Dropdown>
            <Dropdown className="profile-icons">
              <Dropdown.Toggle
                variant="success"
                id="dropdown-basic"
                title={`${props.userInfo.firstname} ${props.userInfo.lastname}`}
                >
                {props?.userInfo?.firstname[0]}
                {props?.userInfo?.lastname[0]}
              </Dropdown.Toggle>
              <Dropdown.Menu>
              <Dropdown.Item onClick={() => handleProfile()}>
                  View Profile
                  <span className="material-icons">person</span>
                </Dropdown.Item>
               
                <Dropdown.Item onClick={() => navigateLogin()}>
                  Log out
                  <span className="material-icons">logout</span>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </header>
        <div className="containerInner">
          <Outlet />
        </div>
        <footer>
          <p>
            Powered by <img src={IntegraLogo} alt="integra-logo" /> | All Rights
            Reserved
          </p>
        </footer>
      </div>
    </div>
  );
}
// props.dispatchAuth(true);
const mapStateToProps = (state: any) => {
  return {
    isLogged: state.rootReducer.authReducer.isLoggedIn,
    isToken: state.rootReducer.authReducer.token,
    userInfo: state.rootReducer.authReducer.userInfo,
    refreshToken: state.rootReducer.authReducer.refreshToken,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    dispatchAuth: (isLogged: any, userData: any, userInfo: any) => {
      dispatchAuth(dispatch, isLogged, userData, userInfo);
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Layout);
